import { TableState } from '../charlie-table';

export const fetchMoreOnScroll = ({
	containerRefElement,
	onScrollTo,
	tableState,
}: {
	containerRefElement?: HTMLDivElement | null;
	onScrollTo: () => void;
	tableState: TableState;
}): void => {
	if (containerRefElement) {
		const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
		//once the user has scrolled within 400px of the bottom of the table, fetch more data if we can
		if (scrollHeight - scrollTop - clientHeight < 400 && tableState !== TableState.loading) {
			onScrollTo();
		}
	}
};
